(() => {
  'use strict';
  const init = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const $ = (s) => root.querySelector(s);
    const $$ = (s) => Array.from(root.querySelectorAll(s));
    const key = root.dataset.storageKey;
    const readDraft = () => { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; } };
    const removeDraft = () => { try { sessionStorage.removeItem(key); } catch { /* Optional recovery only. */ } };
    const node = (tag, text, className) => { const el = document.createElement(tag); if (text != null) el.textContent = text; if (className) el.className = className; return el; };
    const fieldLabels = { business: 'Business', name: 'Contact', email: 'Email', phone: 'Phone', address: 'Delivery address', address2: 'Address line 2', city: 'Suburb / city', region: 'State / region', postcode: 'Postcode', country: 'Country', po: 'Purchase order', notes: 'Notes' };
    const focus = (el) => { el.focus({ preventScroll: true }); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
    function renderSummary(target, snapshot, sent = false) {
      target.replaceChildren();
      target.append(node('h3', 'Skin Botanist · Wholesale order request'));
      target.append(node('p', sent ? 'Submitted for review — awaiting confirmation.' : 'Review copy — not yet submitted.', 'sbo-summary-status'));
      target.append(node('p', 'Request reference: ' + snapshot.reference, 'sbo-reference'));
      const list = node('ul', null, 'sbo-summary-list');
      snapshot.items.forEach((item) => {
        const row = node('li');
        const label = node('div');
        label.append(node('strong', item.product));
        label.append(node('small', item.variant + (item.sku ? ' · SKU ' + item.sku : '')));
        row.append(label, node('b', '× ' + item.quantity));
        list.append(row);
      });
      target.append(list, node('p', snapshot.items.length + ' item line' + (snapshot.items.length === 1 ? '' : 's') + ' · Total quantity: ' + snapshot.items.reduce((n, i) => n + i.quantity, 0), 'sbo-summary-total'));
      target.append(node('p', 'Quantities refer to the selected variant; a pack or set counts as one ordered item.', 'sbo-small'));
      target.append(node('h3', 'Business & delivery'));
      target.append(node('div', Object.entries(fieldLabels).filter(([k]) => snapshot.details[k]).map(([k, label]) => label + ': ' + snapshot.details[k]).join('\n'), 'sbo-summary-details'));
    }
    $$('[data-print]').forEach((button) => button.addEventListener('click', () => window.print()));
    if ($('[data-success]')) {
      const saved = readDraft();
      if (saved?.submittedAt && Date.now() - saved.submittedAt < 3600000 && saved.snapshot?.items?.length) {
        renderSummary($('[data-receipt]'), saved.snapshot, true);
        $('[data-receipt]').hidden = false;
        $('[data-print]').hidden = false;
      }
      removeDraft();
      focus($('[data-success]'));
      return;
    }
    let catalog;
    try { catalog = JSON.parse($('[data-catalog]').textContent).filter((p) => p.variants?.length); } catch { catalog = []; }
    const error = (message) => { $('[data-error]').textContent = message; $('[data-error]').hidden = false; };
    if (!catalog.length) { $('[data-loading]').textContent = 'The product list is currently unavailable. Please email info@skinbotanist.com.au for help with your order.'; return; }
    const form = $('form');
    const lines = $('[data-lines]');
    let sequence = 0;
    let reviewed = null;
    const reference = 'WO-' + (typeof crypto.randomUUID === 'function' ? crypto.randomUUID().replace(/-/g, '').slice(0, 12).toUpperCase() : Date.now().toString(36).toUpperCase());
    $('[data-reference]').value = reference;
    const details = () => Object.fromEntries($$('[data-detail]').map((input) => [input.dataset.detail, input.value.trim()]));
    const rows = () => Array.from(lines.children);
    const draftRows = () => rows().map((row) => ({ productId: row.querySelector('[data-product]').value, variantId: row.querySelector('[data-variant]').value, quantity: row.querySelector('[data-quantity]').value }));
    const writeDraft = (snapshot, submittedAt) => { try { sessionStorage.setItem(key, JSON.stringify({ savedAt: Date.now(), reference: $('[data-reference]').value, rows: draftRows(), details: details(), snapshot, submittedAt })); } catch { /* Storage may be disabled; the form still works. */ } };
    const variantLabel = (v) => v.title === 'Default Title' ? 'Standard item' : v.title;
    const lookup = (row) => { const product = catalog.find((p) => p.id === row.querySelector('[data-product]').value); return { product, variant: product?.variants.find((v) => v.id === row.querySelector('[data-variant]').value) }; };
    const snapshot = () => ({ reference: $('[data-reference]').value, details: details(), items: rows().map((row) => {
      const { product, variant } = lookup(row);
      return { product: product.title, productId: product.id, handle: product.handle, variant: variantLabel(variant), variantId: variant.id, sku: variant.sku || '', quantity: Number(row.querySelector('[data-quantity]').value) };
    }) });
    function validateRows() {
      const selected = new Map();
      rows().forEach((row) => {
        const input = row.querySelector('[data-variant]');
        input.setCustomValidity('');
        const { variant } = lookup(row);
        if (variant && selected.has(variant.id)) input.setCustomValidity('This variant is already in your order. Update its quantity on the existing line or choose another variant.');
        if (variant) selected.set(variant.id, row);
        const quantity = row.querySelector('[data-quantity]');
        quantity.setCustomValidity('');
        if (quantity.value && (!Number.isSafeInteger(Number(quantity.value)) || Number(quantity.value) < 1 || Number(quantity.value) > 9999)) quantity.setCustomValidity('Enter a whole quantity between 1 and 9999.');
      });
    }
    function updateRows() {
      rows().forEach((row, i) => {
        row.querySelector('[data-line-title]').textContent = 'Item ' + (i + 1);
        row.querySelector('[data-remove]').setAttribute('aria-label', 'Remove item ' + (i + 1));
        row.querySelector('[data-remove]').disabled = rows().length === 1;
      });
      $('[data-count]').textContent = rows().length + ' item line' + (rows().length === 1 ? '' : 's') + ' added. You can review and edit before sending.';
      $('[data-add]').disabled = rows().length >= 50;
      validateRows();
    }
    function addRow(saved) {
      if (rows().length >= 50) return;
      const id = ++sequence;
      const row = node('div', null, 'sbo-line');
      const heading = node('div', null, 'sbo-line-heading');
      const title = node('strong'); title.dataset.lineTitle = '';
      const remove = node('button', 'Remove', 'sbo-remove'); remove.type = 'button'; remove.dataset.remove = '';
      heading.append(title, remove);
      const grid = node('div', null, 'sbo-line-fields');
      const thumb = node('div', '✦', 'sbo-thumb sbo-thumb-placeholder'); thumb.setAttribute('aria-hidden', 'true');
      const productLabel = node('label', 'Product *', 'sbo-product-label');
      const product = node('select'); product.dataset.product = ''; product.required = true; product.id = form.id + '-product-' + id; productLabel.htmlFor = product.id;
      product.append(new Option('Select a product', ''));
      catalog.forEach((p) => product.append(new Option(p.title, p.id)));
      productLabel.append(product);
      const variantLabelEl = node('label', 'Variant *');
      const variant = node('select'); variant.dataset.variant = ''; variant.required = true; variant.disabled = true; variant.id = form.id + '-variant-' + id; variantLabelEl.htmlFor = variant.id;
      variant.append(new Option('Choose product first', ''));
      const note = node('span', null, 'sbo-variant-note'); note.id = variant.id + '-note'; variant.setAttribute('aria-describedby', note.id);
      variantLabelEl.append(variant, note);
      const quantityLabel = node('label', 'Quantity *');
      const quantity = node('input'); quantity.dataset.quantity = ''; quantity.type = 'number'; quantity.min = '1'; quantity.max = '9999'; quantity.step = '1'; quantity.inputMode = 'numeric'; quantity.required = true; quantity.value = saved?.quantity || ''; quantity.id = form.id + '-quantity-' + id; quantityLabel.htmlFor = quantity.id;
      quantityLabel.append(quantity);
      grid.append(thumb, productLabel, variantLabelEl, quantityLabel); row.append(heading, grid); lines.append(row);
      function updateVariantNote() {
        const { variant: selected } = lookup(row);
        note.textContent = selected && !selected.available ? 'Availability to be confirmed.' : '';
      }
      function selectProduct() {
        const selected = catalog.find((p) => p.id === product.value);
        variant.replaceChildren(new Option(selected ? 'Select a variant' : 'Choose product first', ''));
        variant.disabled = !selected;
        thumb.replaceChildren(node('span', '✦'));
        if (selected) {
          selected.variants.forEach((v) => variant.append(new Option(variantLabel(v), v.id)));
          if (selected.variants.length === 1) variant.value = selected.variants[0].id;
          if (selected.image) { const img = node('img'); img.src = selected.image; img.alt = ''; img.width = 60; img.height = 64; img.className = 'sbo-thumb'; img.style.margin = '0'; thumb.replaceChildren(img); }
        }
        updateVariantNote(); updateRows();
      }
      product.addEventListener('change', selectProduct);
      variant.addEventListener('change', updateVariantNote);
      remove.addEventListener('click', () => { const previous = row.previousElementSibling || row.nextElementSibling; row.remove(); updateRows(); writeDraft(); if (previous) previous.querySelector('[data-product]').focus(); });
      if (saved?.productId) { product.value = saved.productId; selectProduct(); if (saved.variantId) variant.value = saved.variantId; updateVariantNote(); }
      updateRows();
      return row;
    }
    function valid() {
      $$('[data-detail]').forEach((input) => { if (input.required) input.setCustomValidity(input.value.trim() ? '' : 'Please complete this field.'); });
      validateRows();
      return form.reportValidity();
    }
    function bodyText(data) {
      const d = data.details;
      const text = ['SKIN BOTANIST', 'Wholesale order request', 'Reference: ' + data.reference, '', 'ORDER ITEMS', '────────────────────────'];
      data.items.forEach((item) => {
        text.push(item.product);
        if (item.variant && item.variant !== 'Standard item' && item.variant !== 'Default Title') text.push('Variant: ' + item.variant);
        text.push('Quantity: ' + item.quantity, '');
      });
      text.push('Total quantity: ' + data.items.reduce((n, item) => n + item.quantity, 0));
      text.push('Quantities are for the selected item or pack.', '', 'BUSINESS & CONTACT', '────────────────────────', d.business, 'Contact: ' + d.name);
      // Shopify already displays the required email field above this message.
      if (d.phone) text.push('Phone: ' + d.phone);
      if (d.po) text.push('Purchase order: ' + d.po);
      text.push('', 'DELIVERY ADDRESS', '────────────────────────', d.address);
      if (d.address2) text.push(d.address2);
      text.push([d.city, d.region, d.postcode].filter(Boolean).join(' '), d.country);
      if (d.notes) text.push('', 'NOTES', '────────────────────────', d.notes);
      text.push('', 'Awaiting confirmation of availability, freight and payment.');
      return text.join('\n');
    }
    function edit() {
      $('[data-editor]').hidden = false; $('[data-review-panel]').hidden = true; $('[data-confirm]').required = false; $('[data-confirm]').checked = false; $('[data-submit]').disabled = true; reviewed = null; focus($('[data-review]'));
    }
    $('[data-add]').addEventListener('click', () => { const row = addRow(); writeDraft(); row?.querySelector('[data-product]').focus(); });
    form.addEventListener('input', (event) => { if (event.target.matches('[data-detail], [data-quantity]')) event.target.setCustomValidity(''); validateRows(); $('[data-error]').hidden = true; if (!event.target.matches('[data-confirm]')) writeDraft(); });
    form.addEventListener('change', (event) => { validateRows(); if (!event.target.matches('[data-confirm]')) writeDraft(); });
    $('[data-review]').addEventListener('click', () => {
      if (!valid()) return;
      const data = snapshot(); reviewed = JSON.stringify(data);
      $('[data-body]').value = bodyText(data);
      renderSummary($('[data-summary]'), data);
      $('[data-editor]').hidden = true; $('[data-review-panel]').hidden = false;
      $('[data-confirm]').required = true; $('[data-confirm]').checked = false; $('[data-submit]').disabled = true;
      $('[data-error]').hidden = true; writeDraft(data); focus($('[data-review-heading]'));
    });
    $('[data-edit]').addEventListener('click', edit);
    $('[data-confirm]').addEventListener('change', () => { $('[data-submit]').disabled = !$('[data-confirm]').checked; });
    form.addEventListener('submit', (event) => {
      if (!reviewed || $('[data-review-panel]').hidden || !$('[data-confirm]').checked) { event.preventDefault(); error('Please review your order and check the confirmation box before sending.'); focus($('[data-error]')); return; }
      if (!valid()) { event.preventDefault(); edit(); error('Please check your order details.'); return; }
      const data = snapshot();
      if (JSON.stringify(data) !== reviewed) { event.preventDefault(); edit(); error('Your order has changed. Please review it again before sending.'); return; }
      $('[data-body]').value = bodyText(data);
      writeDraft(data, Date.now());
      // Keep native Shopify contact submission and spam protection intact.
    });
    const saved = readDraft();
    if (saved?.savedAt && Date.now() - saved.savedAt < 86400000 && Array.isArray(saved.rows) && saved.rows.length) {
      saved.rows.slice(0, 50).forEach(addRow);
      $$('[data-detail]').forEach((input) => { if (typeof saved.details?.[input.dataset.detail] === 'string') input.value = saved.details[input.dataset.detail]; });
      if (typeof saved.reference === 'string') $('[data-reference]').value = saved.reference;
    } else { removeDraft(); addRow(); }
    $('[data-loading]').hidden = true;
    $('[data-editor]').hidden = false;
    if ($('[data-server-errors]')) focus($('[data-server-errors]'));
  };
  document.querySelectorAll('[data-wholesale-order]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-wholesale-order]').forEach(init));
})();
